import storeModule from '../../store-module'
import { defineStore } from 'pinia'

const url = 'dashboard/team-sales'

export default defineStore('dashboard-team-sales',
  storeModule.createStoreModule('dashboard-team-sales', {
    fetchListURL: url,
    fetchFiltersURL: `${url}/filters`
  })
)
